function getElementoPadre(padre) {
  let elementoPadre;
  if (padre instanceof String) {
    elementoPadre = document.querySelector(padre);
  } else {
    elementoPadre = padre;
  }
  return elementoPadre;
}

/**
 * Lo que hace es simular el conector de eventos delegado de jquery
 * ($.on('padre', 'hijo', 'click', ...)) pero con javascript
 * @param {*} padre Puede ser un Element o un string que sea un selector
 * @param {*} selectorHijos
 * @param {*} evento
 * @param {*} callback
 */
// eslint-disable-next-line import/prefer-default-export
export function eventDelegation(padre, selectorHijos, evento, callback) {
  getElementoPadre(padre).addEventListener(evento, (event) => {
    if (event.target.matches(selectorHijos)) {
      callback(event);
    }
  });
}

/**
 * Lo que hace es simular el conector de eventos delegado de jquery
 * ($.on('padre', 'hijo', 'click', ...)) pero con javascript
 * Devuelve el método remove() que desconecta el evento
 *
 * Ojo!! Hay eventos que no s
 * @param {*} padre
 * @param {*} selectorHijos
 * @param {*} evento
 * @param {*} listener
 * @param {*} options
 * @returns
 */
export function useEventDelegation(padre, selectorHijos, evento, listener, options) {
  const elementoPadre = getElementoPadre(padre);

  const callback = (event) => {
    if (event.target.matches(selectorHijos)) {
      listener(event);
    }
  };

  elementoPadre.addEventListener(evento, callback, options);

  return {
    remove: () => elementoPadre.removeEventListener(evento, callback, options),
  };
}
